import { useEffect, useState } from 'react';
import InputField from '../../../components/Forms/Input/InputField';
import SimpleSearchSelect from '../../../components/Forms/Input/SimpleSearchSelect';
import { useImportPurchase } from '../../../hooks/purchases/useImportPurchase';
import { useProduct } from '../../../hooks/useProduct';

interface Props {
  onClose: () => void;
}

const EditImportProductForm = ({ onClose }: Props) => {
  
  const { 
    productToEdit, 
    clearProductToEdit,
     handlerUpdateProduct
     } = useImportPurchase();
     
  const { 
    handlerGetProductsForDropdownByItemType, 
    productsDropdown 
  } = useProduct();

  const [form, setForm] = useState(productToEdit);
  const [errors, setErrors] = useState<Record<string, string>>({});

  useEffect(() => {
    handlerGetProductsForDropdownByItemType(1); // Trae productos del backend

    if (productToEdit) {
      setForm(productToEdit); // Carga el producto actual en el formulario
    }
  }, [productToEdit]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((prev: any) => ({ ...prev, [name]: value }));
  };

  const handleUpdate = () => {
    const newErrors: typeof errors = {};
    if (!form?.productId) newErrors.productId = 'Producto requerido';
    if (!form?.quantity) newErrors.quantity = 'Cantidad requerida';
    if (!form?.amount) newErrors.amount = 'Monto requerido';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const payload = {
      detailId: form.id, // 👈 se renombra a detailId
      productId: form.productId,
      quantity: Number(form.quantity),
      amount: Number(form.amount),
    };

    handlerUpdateProduct(payload);
    clearProductToEdit(); // Limpiamos estado global
  };

  if (!form) return null; // Asegurarse de que hay datos

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <SimpleSearchSelect
        label="Producto"
        name="productId"
        iconKey="category"
        options={productsDropdown}
        selectedValue={form.productId}
        onSelect={(option: any) => {
          setForm((prev: any) => ({
            ...prev,
            productId: option.id,
            productName: option.name,
            unit: option.unit || '', // 👈 si querés que aparezca unidad
          }));
        }}
        error={errors.productId}
        required
      />

      {/* 🔒 Unidad de medida (solo lectura) */}
      <InputField
        label="Unidad de Medida"
        name="unit"
        iconKey="unitMeasure"
        value={form.unit || ''}
        disabled
        type="text"
      />

      {/* 🔒 Categoría del producto (solo lectura) */}
      <InputField
        label="Categoría"
        name="category"
        iconKey="category"
        value={form.category || ''}
        type="text"
        disabled
      />

      <InputField
        label="Cantidad"
        name="quantity"
        iconKey="product"
        type="number"
        value={form.quantity}
        onChange={handleChange}
        error={errors.quantity}
        required
      />

      <InputField
        label="Monto"
        name="amount"
        iconKey="dollar"
        type="number"
        value={form.amount}
        onChange={handleChange}
        error={errors.amount}
        required
      />

      {/* Botones - ocupan toda la fila */}
      <div className="col-span-1 mt-6 flex flex-col items-center justify-end gap-3 sm:col-span-2 sm:flex-row">
        <button
          type="button"
          onClick={handleUpdate}
          className="w-full rounded bg-primary px-4 py-2 text-white hover:bg-opacity-90 sm:w-auto"
        >
          Actualizar
        </button>
        <button
          type="button"
          onClick={() => {
            clearProductToEdit();
            onClose();
          }}
          className="w-full rounded bg-slate-500 px-4 py-2 text-white hover:bg-opacity-90 sm:w-auto"
        >
          Cancelar
        </button>
      </div>
    </div>
  );
};

export default EditImportProductForm;
